<template>
  <v-layout row wrap data-qa="debitdetails-layout-luawap">
    <Loader v-if="loaderEnabled" />
    <v-layout wrap class="ml-2" data-qa="debitdetails-layout-sh25z">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="debitdetails-flex-ahw4bk">
        <v-container class="pa-6 pl-12" data-qa="debitdetails-container-70qan8">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="debitdetails-flex-yznmpzd">
            <v-row no-gutters data-qa="debitdetails-row-hvxfs">
              <v-layout row wrap class="pb-2" data-qa="debitdetails-layout-v6dk4f">
                <inline-svg
                  class="mt-2"
                  :src="getNavigationIcon()"
                  width="50"
                  height="50"
                  aria-label="Navigation Icon"
                ></inline-svg>
                <font
                  class="display-1 font-weight-thin white--text pt-4 pl-2"
                  >{{ $t("cardDetails.debitLabel") }}</font
                >
              </v-layout>
            </v-row>
            <v-row data-qa="debitdetails-row-w2lv9t">
              <v-layout wrap class="pl-4" data-qa="debitdetails-layout-krmqe">
                <v-layout column wrap data-qa="debitdetails-layout-egsasm">
                  <v-flex xs6 sm4 md6 lg4 xl4 class="px-1" data-qa="debitdetails-flex-in7pza">
                    <font class="subheading-1 font-weight-medium white--text">{{
                      $t("cardDetails.accountNumber")
                    }}</font>
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg4 xl4 class="px-1" data-qa="debitdetails-flex-ihfplh">
                    <font class="text-h5 font-weight-bold white--text">{{
                      cardAccountNumber
                    }}</font>
                  </v-flex>
                </v-layout>
                <v-layout column wrap data-qa="debitdetails-layout-h24m6o">
                  <v-flex xs6 sm4 md6 lg4 xl4 class="px-1" data-qa="debitdetails-flex-a2ub4">
                    <font class="subheading-1 font-weight-medium white--text">{{
                      $t("cardDetails.cardMaskedNumber")
                    }}</font>
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg4 xl4 class="px-1" data-qa="debitdetails-flex-43p5gg">
                    <font class="text-h5 font-weight-bold white--text">{{
                      cardMaskedNumber
                    }}</font>
                  </v-flex>
                </v-layout>

                <v-layout column wrap data-qa="debitdetails-layout-rez4c">
                  <v-flex xs6 sm4 md6 lg4 xl4 class="px-1" data-qa="debitdetails-flex-m65dl">
                    <font class="subheading font-weight-medium white--text">{{
                      $t("cardDetails.cardName")
                    }}</font>
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg4 xl4 class="px-1" data-qa="debitdetails-flex-89h5zq">
                    <font class="text-h5 font-weight-bold white--text">{{
                      cardName
                    }}</font>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-tabs
      v-model="currentTab"
      v-if="!isFetchingData"
      :color="primaryColor"
      class="pl-2"
     data-qa="debitdetails-tabs-4yzrt">
      <v-tab v-for="(item, i) of tabLabels" :key="i" class="px-6" :data-qa="`debitdetails-tab-dvu7zm-${i}`">
        <font class="subtitle-1 text-capitalize font-weight-bold px-6">{{
          item
        }}</font>
      </v-tab>
    </v-tabs>
    <v-container fluid v-if="!isFetchingData" data-qa="debitdetails-container-st6u8f">
      <v-flex lg10 data-qa="debitdetails-flex-ycjy4o">
        <v-tabs-items v-model="currentTab" data-qa="debitdetails-tabs-items-2e7ndn">
          <!-- Details Tab-->
          <v-tab-item data-qa="debitdetails-tab-item-o2xtxe">
            <v-row :style="{ background: defaultBackgroundColor }" class="pl-2" data-qa="debitdetails-row-ir4pv">
              <v-card tile class="py-2 pt-4" width="618" data-qa="debitdetails-card-db3gj3">
                <DisplayDetails
                  :config="{
                    title: $t('cardDetails.cardInfo'),
                    dataList: cardDetails,
                    translation: 'cardDetails',
                  }"
                  class="pl-5"
                />
              </v-card>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
      <!--ALERT-->
    </v-container>
  </v-layout>
</template>

<script>
import commonService from '@/service/commonService.js'
// import Transactions from '@/views/accounts/Transactions'
import DisplayDetails from '@/views/common/DisplayDetails.vue'
// import PaymentStatus from '@/views/accounts/PaymentStatus'
// import OtpInput from '@/components/common/OtpInput.vue'
// import _ from 'lodash'
// import moment from 'moment'
// import event from '@/util/event'
// import store from '@/core/store'
import Loader from '../../../components/common/Loader.vue'
import '@/styles/pages/accounts/creditCards.scss'
export default {
  name: 'DebitDetails',
  props: {
    config: {
      type: Object,
      default: undefined
    }
  },
  components: {
    Loader,
    // Transactions,
    DisplayDetails
    // PaymentStatus,
    // OtpInput
  },
  data () {
    return {
      loaderEnabled: false,
      currentTab: 0,
      tabLabels: ['Details'],
      isFetchingData: false,
      cardDetails: [],
      cardLimits: [],
      cardExpiryDate: ''
    }
  },
  async created () {
    this.cardId = this.config.params.cardId
    this.cardAccountNumber = this.config.params.cardAccountNumber
    this.cardName = this.config.params.cardName
    this.cardMaskedNumber = this.config.params.cardMaskedNumber
    await this.getAccountDetails(this.cardId)
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('debit2')
    },
    async getAccountDetails (cardId) {
      const detailsResponse = await commonService.getDebitCardDetails(cardId)
      this.cardExpiryDate = this.$formatter.formatDate(
        detailsResponse.expiryDate
      )
      if (detailsResponse && !detailsResponse.causes) {
        this.cardDetails.push(
          {
            label: 'debitCardProduct',
            value: detailsResponse.debitCardProductName
          },
          {
            label: 'cardStatus',
            value: detailsResponse.cardStatus
          },
          {
            label: 'expiryDate',
            value: this.cardExpiryDate
              ? this.cardExpiryDate.substr(3, 2) +
                '/' +
                this.cardExpiryDate.substr(8, 2)
              : ''
          }
        )
      }
    }
  }
}
</script>
